import { generateAsyncReducer } from '../../../utils';
import { EAgencyActions } from './enums';
import { IAgency } from './models';

export const AgencyReducers = generateAsyncReducer<IAgency>(EAgencyActions.GET_AGENCY);
